import { createRoot } from 'react-dom/client';
import App from './App';
import { installCsrfFetchInterceptor } from './lib/csrf';
import { installSharedTemplateTokenCapture } from './lib/pendingSharedTemplate';
import { initScribeSentry } from './lib/sentry';
import './index.css';

// Move a shared-template token from the URL fragment into sessionStorage before Sentry starts
// recording URLs (breadcrumbs, pageload, replay) and before any route redirect.
installSharedTemplateTokenCapture();
// Initialize Sentry as early as possible
initScribeSentry();
// Attach the session CSRF token to all same-origin mutating requests
installCsrfFetchInterceptor();

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element not found');
}
createRoot(rootElement).render(<App />);
